export const environment = {
  production: import.meta.env.NG_APP_PRODUCTION == 'true',
  clientId: import.meta.env.NG_APP_CLIENTID,
  authority: import.meta.env.NG_APP_AUTHORITY,
  redirectUri: import.meta.env.NG_APP_REDIRECT_URL,
  apiScopeUrl: import.meta.env.NG_APP_SCOPE_URL,
  graphApi: import.meta.env.NG_APP_GRAPH_API,
  env: import.meta.env.NG_APP_ENV,
  apimBaseUrl: import.meta.env.NG_APP_APIM_BASE_URI,
  apimSubKey: import.meta.env.NG_APP_APIM_SUBSCRIPTION_KEY,
  apimNcVersion: import.meta.env.NG_APP_APIM_NERVECENTER_VERSION,
  csappsVersion: import.meta.env.NG_APP_CSAPPS_VERSION,
  currentRole: import.meta.env.NG_APP_CURRENT_ROLE,
  csappsAppmgtVersion: import.meta.env.NG_APP_CSAPPS_APPMGT_VERSION,
  digitalApi: import.meta.env.NG_APP_DIGITAL_API,
  productId: import.meta.env.NG_APP_PLATFORM_APP_ID,
  superAdminRoleId: import.meta.env.NG_APP_SUPER_ADMIN_ROLE_ID
};
